import {CheckIcon} from 'lucide-react';
import * as React from 'react';

import {cn} from '../../libs';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({className, ...props}, ref) => {
  return (
    <div className="relative flex items-center">
      <input type="checkbox" ref={ref} className="peer sr-only" {...props} />
      <div
        className={cn(
          'peer size-4 shrink-0 rounded-[4px] border border-border-primary bg-bg-secondary text-transparent shadow-xs outline-none transition-none',
          'peer-checked:border-brand-secondary peer-checked:bg-brand-secondary peer-checked:text-text-contrast',
          'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
          'peer-aria-invalid:border-destructive peer-aria-invalid:ring-destructive/20',
          className,
        )}
      >
        <div className="flex h-full w-full items-center justify-center">
          <CheckIcon className="size-full" />
        </div>
      </div>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export {Checkbox};
